<template>
    <section
        class="lg:bg-[url('/homepage/Ad-Banner-d.svg')] bg-[url('/homepage/Ad-Banner-s.svg')] h-[588px] lg:max-h-[270px] lg:h-fit bg-center bg-cover py-20 px-4 lg:px-10 bg-no-repeat w-full lg:bg-black"
    >
        <div class="flex lg:flex-row flex-col lg:justify-between justify-center items-center container h-full">
            <h3 class="text-display-lg font-bold lg:text-start text-center text-gray-100 max-w-[484px]">
                {{ item.title }}
            </h3>
            <NuxtLinkLocale :id to="/dashboard/services">
                <AppButton :id class="!px-10" color="white">
                    {{ $t(auth ? "global_letsGo" : "landingComponents_hero_tryForFree_test") }}
                </AppButton>
            </NuxtLinkLocale>
        </div>
    </section>
</template>

<script lang="ts" setup>
import type { ICta } from "~/types/components/landings.type";
interface Props {
    item: {
        title: string;
        button?: ICta;
    };
    id?: string;
}

const auth = useAuth();

withDefaults(defineProps<Props>(), {});
</script>
